var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6341 20.8333H86.3658C87.7535 20.8333 88.8889 21.981 88.8889 23.3836V63.5438C88.8889 64.9464 87.7535 66.094 86.3658 66.094H61.0181V72.8338H78.423C79.4745 72.8338 80.332 73.7006 80.332 74.7634V77.2377C80.332 78.2999 79.4745 79.1667 78.423 79.1667H21.5776C20.5261 79.1667 19.6686 78.2999 19.6686 77.2377V74.7634C19.6686 73.7006 20.5261 72.8338 21.5776 72.8338H38.9825V66.094H13.6341C12.2464 66.094 11.1111 64.9464 11.1111 63.5438V23.3836C11.1111 21.981 12.2464 20.8333 13.6341 20.8333ZM20.8124 28.6089H79.1876C80.1981 28.6089 81.0255 29.4445 81.0255 30.4667V55.294C81.0255 56.3161 80.1981 57.1517 79.1876 57.1517H20.8124C19.8018 57.1517 18.9745 56.3161 18.9745 55.294V30.4667C18.9745 29.4445 19.8018 28.6089 20.8124 28.6089Z",
    fill: "#39B980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.c9c58b6ebc232d6700f5e2c48f83ebd0.svg";
export { ForwardRef as ReactComponent };